import { Card } from '@iwoca/orion';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './ApplicationLoader.module.css';

export const ApplicationLoader = () => {
  return (
    <section data-testid="application-loader" className={styles.loader}>
      <div className={styles.titleContainer}>
        <SkeletonTheme baseColor="#BAD1DE" borderRadius={50} height={24}>
          <Skeleton className={styles.title} />
          <Skeleton className={styles.title} width="60%" />
        </SkeletonTheme>
      </div>
      <Card className={styles.card}>
        <SkeletonTheme height={20} borderRadius={50}>
          <div className={styles.headerColumn}>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
          </div>
          <div className={styles.valueColumn}>
            <div className={styles.productType}>
              <Skeleton className={styles.value} height={57} borderRadius={0} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} width="60%" />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} width="60%" />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} />
            </div>
            <div className={styles.valueContainer}>
              <Skeleton className={styles.value} width="60%" />
            </div>
            <div className={styles.button}>
              <Skeleton className={styles.value} height={57} borderRadius={0} />
            </div>
          </div>
        </SkeletonTheme>
      </Card>
    </section>
  );
};
